import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m4.242 13.895 9.653-9.653a.828.828 0 0 1 1.17 0l.693.692a.828.828 0 0 1 0 1.17l-9.653 9.654a.828.828 0 0 1-1.17 0l-.693-.692a.828.828 0 0 1 0-1.17ZM12 7l1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path fill-rule="evenodd" clip-rule="evenodd" d="m8 3 .54 1.46L10 5l-1.46.54L8 7l-.54-1.46L6 5l1.46-.54L8 3Zm8.5 6 .405 1.095L18 10.5l-1.095.405L16.5 12l-.405-1.095L15 10.5l1.095-.405L16.5 9Z" fill="currentColor" />' }
  })
);